import { render } from "./ContactUs.vue?vue&type=template&id=5ca4f732&ts=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=5ca4f732&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/marlu-store-locator-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__